import { render, staticRenderFns } from "./salesInvoiceTask.vue?vue&type=template&id=e4fc5108&scoped=true"
import script from "./salesInvoiceTask.vue?vue&type=script&lang=js"
export * from "./salesInvoiceTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fc5108",
  null
  
)

export default component.exports